import {VoucherBaseModel} from "../voucher-base.model";

export class JackpotFreeSpinsVoucherModel extends VoucherBaseModel {

    get voucherName(): string {
        return this.services.translation.translate('FREE_PLAY_VOUCHER_NAME_JPFSV');
    }


    get voucherDescription(): string {
        return this.services.translation.translate('FREE_PLAY_VOUCHER_DESC_JPFSV');
    }

    get voucherInGameTitle(): string {
        return this.services.translation.translate('FREE_PLAY_VOUCHER_TITLE_JPFSV');
    }

    protected _formatVoucherAmount(amount: number): string {
        return (amount / this._voucherData.SpinBetAmount).toString();
    }

    get backgroundImageUrl(): string {
        return this.services.theme.currentTheme.assets.images.free_play.freeplay_bg_type_jfs_png.toString();
    }

    get iconUrl(): string {
        return this.services.theme.currentTheme.assets.images.free_play.freeplay_type_jfs_png.toString();
    }

}